<template>
  <div class="card">
    <div class="card-header align-items-center d-flex">
      <h4 class="card-title mb-0 flex-grow-1">{{this.$t('page.atlas-analysis.DataScience')}}</h4>
    </div>
    <div class="card-body align-items-center d-flex flex-column justify-content-center" style="position:relative;background: #F3F6F9;align-items:center;padding: 0;" >
      <img style="position:absolute;height:247px;width:100%;top:0px" src="./cover2.png" alt="" srcset="">
      <div class="fs-20" style="font-weight: 500;color: #6D7080;">{{this.$t('page.atlas-analysis.ComingSoon')}}</div>
    </div>
  </div>
</template>